import { useState, useCallback } from 'react';
import { factoriesApi } from '../configs/api_endpoints.config';
import { apiService } from '../services/api.service';

export function useFactoryData() {
  const [availableDepartments, setAvailableDepartments] = useState([]);
  const [availableCountries, setAvailableCountries] = useState([]);
  const [isLoadingDepartments, setIsLoadingDepartments] = useState(false);

  const fetchDepartmentsFromFactories = useCallback(async (factories) => {
    if (!factories || factories.length === 0) {
      setAvailableDepartments([]);
      setAvailableCountries([]);
      return;
    }

    setIsLoadingDepartments(true);

    try {
      const factoryDataPromises = factories.map(async (factory) => {
        const searchId = factory.dss_id || factory.factory_id || factory.id;
        if (!searchId) {
          return { departments: [], countries: [] };
        }

        try {
          const response = await apiService.get(factoriesApi.search, {
            offset: 0,
            limit: 10,
            search: searchId,
          });

          const factoriesArray = response.data?.data || response.data;

          if (
            factoriesArray &&
            Array.isArray(factoriesArray) &&
            factoriesArray.length > 0
          ) {
            const factoryData = factoriesArray[0];
            const departments = factoryData.departments || [];

            const countries = [];
            if (factoryData.port_of_loading) {
              countries.push(factoryData.port_of_loading);
            }

            return { departments, countries };
          }
          return { departments: [], countries: [] };
        } catch (error) {
          console.error(`Error fetching data for factory ${searchId}:`, error);
          return { departments: [], countries: [] };
        }
      });

      const allFactoryData = await Promise.all(factoryDataPromises);

      const allDepartments = allFactoryData.flatMap((data) => data.departments);
      const deptMap = new Map();
      allDepartments.forEach((dept) => {
        if (!deptMap.has(dept.id)) {
          deptMap.set(dept.id, dept);
        }
      });
      const uniqueDepartments = Array.from(deptMap.values());

      const allCountries = allFactoryData.flatMap((data) => data.countries);
      const countryMap = new Map();
      allCountries.forEach((country) => {
        if (!countryMap.has(country.id)) {
          countryMap.set(country.id, country);
        }
      });
      const uniqueCountries = Array.from(countryMap.values());

      setAvailableDepartments(uniqueDepartments);
      setAvailableCountries(uniqueCountries);
    } catch (error) {
      console.error('Error fetching factory data:', error);
      setAvailableDepartments([]);
      setAvailableCountries([]);
    } finally {
      setIsLoadingDepartments(false);
    }
  }, []);

  return {
    availableDepartments,
    setAvailableDepartments,
    availableCountries,
    setAvailableCountries,
    isLoadingDepartments,
    fetchDepartmentsFromFactories,
  };
}
